// import { Injectable } from '@angular/core';
// import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
// import { Observable, of } from 'rxjs';
// import { map, catchError, tap } from 'rxjs/operators';
// /* import 'rxjs/add/Observable/throw'; */
// import { environment } from '../../environments/environment';
// const httpOptions = {
//   headers: new HttpHeaders({
//     'Content-Type':  'application/json',
//     'token': localStorage.getItem('pro_bearer_token')
//     // 'Access-Control-Allow-Origin': '*'//
//   })
// };
// const httpOptionslogin = {
//   headers: new HttpHeaders({
//     'Content-Type':  'application/json',
//     // 'Access-Control-Allow-Origin': '*'//
//     'token': localStorage.getItem('pro_bearer_token')
//   })
// };
// @Injectable()
// export class ajaxservice {
//   private extractData(res: Response) {
//     let body = res;
//     return body || { };
//   }
//   private getHeaders(): HttpHeaders {
//     return new HttpHeaders({
//       'Content-Type': 'application/json',
//       'token': localStorage.getItem('pro_bearer_token')
//     });
//   }
//   constructor( private http:HttpClient ) { }
  
//   getdata(url): Observable<any> {
//     return this.http.get(environment.api_url + url).pipe(
//       map(this.extractData));
//   }
//   get(url,data): Observable<any> {
//     return this.http.get<any>(environment.api_url + url,data).pipe(
//       tap((data) => console.log(`get product w/ id=${data}`)),
//       catchError(this.handleError<any>('addProduct'))
//     );
//   }
//   getdataparam(url,id,value): Observable<any> {
//     const headers = this.getHeaders();
//     return this.http.get(environment.api_url + url +id+"="+value, { headers }).pipe(
//     map(this.extractData));
//   }
//   getdatawith2param(url,id,value,id1,value1): Observable<any> {
//     const headers = this.getHeaders();
//     return this.http.get(environment.api_url + url +id+"="+value+"&"+id1+"="+value1, { headers }).pipe(
//     map(this.extractData));
//   }
//   getdatawith3params(url, id1, value1, id2, value2, id3, value3): Observable<any> {
//     const headers = this.getHeaders();
//     console.log(this.http.get(environment.api_url + url + id1 + "=" + value1 + "&" + id2 + "=" + value2 + "&" + id3 + "=" + value3, { headers }).pipe(
//       map(this.extractData)))
//     return this.http.get(environment.api_url + url + id1 + "=" + value1 + "&" + id2 + "=" + value2 + "&" + id3 + "=" + value3, { headers }).pipe(
//       map(this.extractData));
//   }
//   getdataparams(url,data): Observable<any> {
//     console.log(data,"data")
//     return this.http.get(environment.api_url + url +data).pipe(
//     map(this.extractData));
//   }
//    getdatalocation(url,id,value,node,node_id): Observable<any> {
//      return this.http.get(environment.api_url + url +id+"="+value+"&"+node_id+"="+node).pipe(
//     map(this.extractData));
//   } 
//   getdatareimbursement(url, id, value, node, node_id,start_date,start,end_date,end): Observable<any> {
//     return this.http.get(environment.api_url + url + id + "=" + value + "&" + node + "=" + node_id+ "&" + start_date + "=" + start + "&" + end_date + "=" + end ).pipe(
//       map(this.extractData));
//   }  
//   // getdatalocation(url,id,value,id1,value1): Observable<any> {
//   //   return this.http.get(environment.api_url + url +id+"="+value+"&"+id1+"="+value1,httpOptions).pipe(
//   //   map(this.extractData));
//   // }    
//   postdatalogin (url,data): Observable<any> {
//     return this.http.post<any>(environment.api_url + url, JSON.stringify(data)).pipe(
//       tap((data) => console.log(`added product w/ id=${data}`)),
//       catchError(this.handleError<any>('addProduct'))
//     );
//   }
//   postdata (url,data): Observable<any> {

//     const headers = new HttpHeaders({
//       'token': localStorage.getItem('pro_bearer_token'),
//       'Content-Type':  'application/json',
//     });
//     return this.http.post<any>(environment.api_url + url, JSON.stringify(data), { headers }).pipe(
//       tap((data) => console.log(`added product w/ id=${data}`)),
//       catchError(this.handleError<any>('addProduct'))
//     );
//   }
//   public ajaxpost(data: FormData, methods, url) 
//   {
//     const headers = new HttpHeaders({
//       'token': localStorage.getItem('pro_bearer_token')
//     });

//     return this.http.post<any>(environment.api_url+url, data, { headers });
//     // var httpOptions = {
//     //   headers: new HttpHeaders({
//     //     'Content-Type':  'application/json',
//     //     'token': localStorage.getItem('pro_bearer_token')
//     //     // 'Access-Control-Allow-Origin': '*'//
//     //   })
//     // };
//     // var obj = { 
//     // methods: methods,
//     //  submitUrl: url,
//     //  data:data,
//     //  dataType: "JSON" } 
//     //  return this.http.post(environment.api_url + obj.submitUrl,data, httpOptions)
//   }
//   private handleError<T> (operation = 'operation', result?: T) {
//     return (error: any): Observable<T> => {

//       // TODO: send the error to remote logging infrastructure
//       console.error(error); // log to console instead

//       // TODO: better job of transforming error for user consumption
//       console.log(`${operation} failed: ${error.message}`);

//       // Let the app keep running by returning an empty result.
//       return of(result as T);
//     };
//   }
//   //function for pdf call
//   getPdfDocument(url, id, value): any {
//     let headers = new HttpHeaders({ 'Content-Type': 'application/arraybuffer' });
//     return this.http
//     .get(environment.api_url + url + id + "=" + value,
//     { headers: headers, responseType: 'blob' as 'arraybuffer', observe: 'response' as 'body' }
//     );
//     }

//     getPdfDocument1(pdfUrl,pname): any {
//       let headers = new HttpHeaders({ 'Content-Type': 'application/arraybuffer' });
//       return this.http
//       .get(environment.api_url + pdfUrl,
//       { headers: headers, responseType: 'blob' as 'arraybuffer', observe: 'response' as 'body' }
//       );
//       }
      
    
// }
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
/* import 'rxjs/add/Observable/throw'; */
import { environment } from '../../environments/environment';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    // 'Access-Control-Allow-Origin': '*'//
  })
};
@Injectable()
export class ajaxservice {
  private extractData(res: Response) {
    let body = res;
    return body || { };
  }

  constructor( private http:HttpClient ) { }
  
  getdata(url): Observable<any> {
    return this.http.get(environment.api_url + url).pipe(
      map(this.extractData));
  }
  get(url,data): Observable<any> {
    console.log(data);
    // console.log("JSON.stringify(data)"+(data));
    return this.http.get<any>(environment.api_url + url,data).pipe(
      tap((data) => console.log(`get product w/ id=${data}`)),
      catchError(this.handleError<any>('addProduct'))
    );
  }
  getdataparam(url,id,value): Observable<any> {
    return this.http.get(environment.api_url + url +id+"="+value).pipe(
    map(this.extractData));
  }
  getdataparams(url,data): Observable<any> {
    return this.http.get(environment.api_url + url +data).pipe(
    map(this.extractData));
  }
   getdatalocation(url,id,value,node,node_id): Observable<any> {
     return this.http.get(environment.api_url + url +id+"="+value+"&"+node_id+"="+node).pipe(
    map(this.extractData));
  }
  getdatawith3params(url, id1, value1, id2, value2, id3, value3): Observable<any> {
    return this.http.get(environment.api_url + url + id1 + "=" + value1 + "&" + id2 + "=" + value2 + "&" + id3 + "=" + value3).pipe(map(this.extractData));
  } 
  getdatareimbursement(url, id, value, node, node_id,start_date,start,end_date,end): Observable<any> {
    return this.http.get(environment.api_url + url + id + "=" + value + "&" + node + "=" + node_id+ "&" + start_date + "=" + start + "&" + end_date + "=" + end ).pipe(
      map(this.extractData));
  }  
  // getdatalocation(url,id,value,id1,value1): Observable<any> {
  //   return this.http.get(environment.api_url + url +id+"="+value+"&"+id1+"="+value1,httpOptions).pipe(
  //   map(this.extractData));
  // }    
  postdata (url,data): Observable<any> {
    console.log(data);
    console.log("JSON.stringify(data)"+(data));
    return this.http.post<any>(environment.api_url + url, JSON.stringify(data), httpOptions).pipe(
      tap((data) => console.log(`added product w/ id=${data}`)),
      catchError(this.handleError<any>('addProduct'))
    );
  }
  
  public ajaxpost(data, methods, url) 
  {
    var obj = { 
    methods: methods,
     submitUrl: url,
     data:data,
     dataType: "JSON" } 
     return this.http.post(environment.api_url + obj.submitUrl, obj.data)
  }
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
  //function for pdf call
  getPdfDocument(url, id, value): any {
    let headers = new HttpHeaders({ 'Content-Type': 'application/arraybuffer' });
    return this.http
    .get(environment.api_url + url + id + "=" + value,
    { headers: headers, responseType: 'blob' as 'arraybuffer', observe: 'response' as 'body' }
    );
    }

    getPdfDocument1(pdfUrl,pname): any {
      let headers = new HttpHeaders({ 'Content-Type': 'application/arraybuffer' });
      return this.http
      .get(environment.api_url + pdfUrl,
      { headers: headers, responseType: 'blob' as 'arraybuffer', observe: 'response' as 'body' }
      );
      }
        getdatawith2param(url,id,value,id1,value1): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(environment.api_url + url +id+"="+value+"&"+id1+"="+value1, { headers }).pipe(
    map(this.extractData));
  }
    private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'token': localStorage.getItem('pro_bearer_token')
    });
  }
  postdatalogin (url,data): Observable<any> {
        return this.http.post<any>(environment.api_url + url, JSON.stringify(data)).pipe(
          tap((data) => console.log(`added product w/ id=${data}`)),
          catchError(this.handleError<any>('addProduct'))
        );
      }
      
    
}